import React from "react";
import { Reveal, Section, Container, EyebrowLarge } from "./Shared";
import {
    MonitorSmartphone,
    Briefcase,
    Megaphone,
    Users,
    Building2,
    Calendar,
    GraduationCap,
    Handshake,
    Heart,
    ArrowUpRight
} from "lucide-react";

const s1 = require("../../assets/ivani/s1.jpg");
const s2 = require("../../assets/ivani/s2.jpg");
const s3 = require("../../assets/ivani/s3.jpg");
const s4 = require("../../assets/ivani/s4.jpg");
const s5 = require("../../assets/ivani/s5.jpg");
const s6 = require("../../assets/ivani/s6.jpg");
const s7 = require("../../assets/ivani/s7.jpg");
const s8 = require("../../assets/ivani/s8.jpg");
const s9 = require("../../assets/ivani/s9.jpg");

const services = [
    {
        t: "IT Solutions",
        c: "IT Consulting Services, Managed Services, End-to-End Data Center Provisioning, Safe City Solutions",
        img: s1,
        icon: MonitorSmartphone
    },
    {
        t: "Consulting Services",
        c: "Management Consulting, Business Advisory & Consulting",
        img: s2,
        icon: Briefcase
    },
    {
        t: "Marketing & Branding Services",
        c: "Comprehensive Digital Media Services, Social Media, Management, Outreach Solutions, Out of Home Branding",
        img: s3,
        icon: Megaphone
    },
    {
        t: "Staffing and Workforce Solutions",
        c: "Recruitment and Talent Acquisition + Workforce Planning",
        img: s4,
        icon: Users
    },
    {
        t: "Workplace Innovation",
        c: "Office Furnishing, Ergonomic Solutions",
        img: s5,
        icon: Building2
    },
    {
        t: "Event Management",
        c: "Corporate Events and Conferences, Event Planning and Execution",
        img: s6,
        icon: Calendar
    },
    {
        t: "Training & Capability Building",
        c: "Corporate Training, Institutional Training, NGO/CSR Training",
        img: s7,
        icon: GraduationCap
    },
    {
        t: "Partnerships & Ecosystem Building",
        c: "Corporate Partnerships, Institutional Alliances, NGO & CSR Connects, Global Ecosystem Access",
        img: s8,
        icon: Handshake
    },
    {
        t: "Sports & Community Engagement",
        c: "Rural Sports, Tennis Ball Cricket, Corporate Sports for Women",
        img: s9,
        icon: Heart
    },
];

export default function Services() {
    return (
        <Section id="services" className="relative font-body py-24 md:py-32">
            {/* Background Ambience */}
            <div className="absolute top-1/4 right-0 w-[600px] h-[600px] rounded-full blur-[120px] pointer-events-none opacity-[0.15]" style={{ background: 'var(--ivani-color)' }} />
            <div className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full blur-[100px] pointer-events-none opacity-10" style={{ background: 'var(--ivani-color)' }} />

            <Container>
                <div className="text-center mb-16 md:mb-20">
                    <EyebrowLarge className="mb-6">OUR SERVICES</EyebrowLarge>
                    <Reveal>
                        <p className="text-zinc-400 text-lg max-w-2xl mx-auto font-light">
                            From executive hiring to venture introductions and strategic
                            partnerships — we activate our network to unlock outcomes.
                        </p>
                    </Reveal>
                </div>

                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {services.map((s, i) => (
                        <Reveal key={s.t} className="h-full" delay={i * 0.05}>
                            <div className="group h-full glass-card p-4 rounded-[32px] border border-white/10 hover:border-white/20 transition-all duration-500 hover:shadow-2xl flex flex-col hover:-translate-y-2 hover:scale-[1.02] bg-white/5 relative overflow-hidden">

                                {/* Noise Texture */}
                                <div className="absolute inset-0 bg-noise opacity-10 pointer-events-none z-0 mix-blend-overlay"></div>

                                {/* Large Background Icon Watermark */}
                                <s.icon className="absolute -bottom-6 -right-6 w-40 h-40 text-white opacity-5 -rotate-12 pointer-events-none transition-transform duration-700 group-hover:scale-110 z-0" />

                                {/* Image Container */}
                                <div className="rounded-2xl overflow-hidden relative h-56 w-full mb-6 z-10">
                                    <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors z-10"></div>
                                    <img
                                        src={s.img}
                                        alt={s.t}
                                        className="h-full w-full object-cover transform group-hover:scale-110 transition-transform duration-700 grayscale group-hover:grayscale-0"
                                    />
                                </div>

                                {/* Content */}
                                <div className="px-1 pb-2 flex-1 flex flex-col relative z-20">
                                    <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-3 group-hover:text-white transition-colors flex items-center gap-2">
                                        {/* Optional Small Icon in Title */}
                                        {/* <s.icon className="w-5 h-5 text-white/80" /> */}
                                        {s.t}
                                    </h3>
                                    <p className="text-zinc-400 text-base md:text-lg leading-relaxed font-light">
                                        {s.c}
                                    </p>

                                    {/* Action Arrow */}
                                    <div className="mt-auto pt-6 flex justify-end">
                                        <div className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-white group-hover:text-black transition-all duration-300 transform translate-y-2 opacity-50 group-hover:opacity-100 group-hover:translate-y-0">
                                            <ArrowUpRight className="w-5 h-5" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </Container>
        </Section>
    );
}
